import { Tab } from 'react-bootstrap';
import React, { FC } from 'react';
import { SupportInfo } from 'moduleBaseMenu/types/SupportInfo';
import app from 'srcJs/App';
import { Else, If, Then } from 'react-if';
import { IntercomTriggerIcon } from 'components/intercom/components/IntercomTriggerIcon';

type PropTypes = {
  supportInfo: SupportInfo,
};

const SupportContent: FC<PropTypes> = ({
  supportInfo,
}) => {
  if (!supportInfo) {
    return null;
  }

  return (
    <Tab.Pane eventKey="support">
      <div className="fs-22 mb-4 pb-3">
        {app.tForReact('base_menu', 'Help Center')}
      </div>
      <ul className="desktop-nav-list desktop-nav-list--margin-lg">
        <li>
          {app.tForReact('base_menu', 'Support Chat')}
          <If condition={supportInfo.isDisplayIntercom}>
            <Then>
              <IntercomTriggerIcon additionalClassName="mt-2" />
            </Then>
            <Else>
              <div>
                {supportInfo.scheduleChatWeekdays}
              </div>
              <div>
                {supportInfo.scheduleChatWeekend}
              </div>
            </Else>
          </If>
        </li>
        {/* <li>
          <div>
            {app.tForReact('base_menu', 'Phone')}
          </div>
          <div>
            {supportInfo.schedulePhone}
          </div>
        </li>
        <li>
          <div className="mb-8p">
            {app.tForReact('base_menu', 'Technical support')}
          </div>
          <a href={supportInfo.phoneUKR.url} className="d-flex align-items-center color-858585 mt-4p">
            <img src={supportInfo.phoneUKR.image} width="20" className="mr-8p" />
            {supportInfo.phoneUKR.phone}
          </a>
          <a href={supportInfo.phoneRUS.url} className="d-flex align-items-center color-858585 mt-4p">
            <img src={supportInfo.phoneRUS.image} width="20" className="mr-8p" />
            {supportInfo.phoneRUS.phone}
          </a>
        </li> */}
        <li>
          <div>
            {app.tForReact('base_menu', 'Mail')}
          </div>
          <a href={`mailto:${supportInfo.email}`} target="_blank" rel="noreferrer">
            {supportInfo.email}
          </a>
        </li>
      </ul>
    </Tab.Pane>
  );
};

export { SupportContent };
